import Vconsole from 'vconsole';
import Vue from 'vue';
import App from './App.vue';
import VueJsonp from 'vue-jsonp';
import { APP_CONFIG } from './config';
import router from './router';
import store from './store';
import './styles/main.scss'; // global css
import './directive/index';
import { wxService } from './services/wx.service';

Vue.config.productionTip = false;
Vue.use(VueJsonp);

// !!非生产环境的微信环境启用 vconsole
if (!/event.fnws.top/gi.test(APP_CONFIG.baseUrl) && /micromessenger/gi.test(navigator.userAgent)) new Vconsole();
// new Vconsole();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

wxService.init();
